import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["step", "unit", "values"];
import facepaint from 'facepaint';
var defaultUnit = 'px';
var defaultStep = 2;
var defaultValues = {
  xs: 0,
  sm: 480,
  md: 720,
  lg: 1024,
  xl: 1200
}; // Sorted ASC by size. That's important.

var breakpointKeys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

export default function createBreakpoints() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$step = options.step,
      step = _options$step === void 0 ? defaultStep : _options$step,
      _options$unit = options.unit,
      unit = _options$unit === void 0 ? defaultUnit : _options$unit,
      _options$values = options.values,
      values = _options$values === void 0 ? defaultValues : _options$values,
      otherOptions = _objectWithoutProperties(options, _excluded);

  var keys = Object.keys(values);

  function maxWidth(value) {
    var result = value - step / 100;
    return result > 0 ? result : value;
  }

  function up(key) {
    var value = typeof key === 'number' ? key : values[key];
    return "@media (min-width: ".concat(value).concat(unit, ")");
  }

  function down(key) {
    var value = typeof key === 'number' ? key : values[key];
    return "@media (max-width: ".concat(maxWidth(value)).concat(unit, ")");
  }

  function between(start, end) {
    var startValue = typeof start === 'number' ? start : values[start];
    var endValue = typeof end === 'number' ? end : values[end];
    return "@media (min-width: ".concat(startValue).concat(unit, ") and (max-width: ").concat(maxWidth(endValue)).concat(unit, ")");
  }

  function only(key) {
    var keyIndex = breakpointKeys.indexOf(key);

    if (keyIndex === 0) {
      return down(key);
    }

    if (keyIndex + 1 < keys.length) {
      return between(key, breakpointKeys[keyIndex + 1]);
    }

    return up(key);
  }

  return _objectSpread({
    keys: breakpointKeys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    mq: facepaint(breakpointKeys.slice(1).map(function (bp) {
      return up(bp);
    }))
  }, otherOptions);
}